module.exports = __webpack_public_path__ + "img/logo.f960974a.svg";